export const SET_EMAIL = "SET_EMAIL";
export const FALSE_EMAIL = "FALSE_EMAIL";
